import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useState, useRef } from 'react';
import { Steps } from "primereact/steps";
import FormCrearSubproductoFicha from "./FormCrearSubproductoFicha";

const FormCrearSubproducto = ({
  displayDialog,
  setDisplayDialog,
  descripcion,
  setDescripcion,
  tipo,
  setTipo,
  metraje,
  setMetraje,
  tipoOptions,
  handleCreateSubproducto,
  loading,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [guardando, setGuardando] = useState(false);
  const guardandoRef = useRef(false);
  const stepsItems = [{ label: "Subproducto", command: () => setActiveStep(0) }, { label: "Ficha técnica", command: () => setActiveStep(1) }, ];
  const handleStepChange = (e) => { setActiveStep(e.index); };
  const fichaRef = useRef(null);

  const limpiarFormulario = () => {
    setDescripcion("");
    setTipo(null);
    setMetraje(null);
    setActiveStep(0);
    setDisplayDialog(false);
  };

  const handleCrearSubproducto = async () => {
    if (guardandoRef.current) return;
    guardandoRef.current = true;
    setGuardando(true);
    try {
      // Capturar datos de la ficha ANTES de que el diálogo se cierre
      let fichaData = null;
      if (fichaRef.current) {
        fichaData = fichaRef.current.getData();
        if (fichaData?.fichaJson === "{}") {
          fichaData = null;
        }
      }

      await handleCreateSubproducto(fichaData);
    } catch (error) {
      console.error("Error al crear subproducto:", error);
    } finally {
      guardandoRef.current = false;
      setGuardando(false);
    }
  };

  const footerCrearSubprod = () => {
    return (
      <div className="p-d-flex p-jc-end p-mt-3">
        <Button
          label="Cancelar"
          icon="pi pi-times"
          onClick={limpiarFormulario}
          className="p-button p-mr-2 p-button-outlined p-button-rounded"
        />
        <Button
          label="Guardar"
          icon={guardando ? "pi pi-spin pi-spinner" : "pi pi-save"}
          onClick={handleCrearSubproducto}
          className="p-button-success p-button-rounded p-button"
          raised
          autoFocus
          disabled={guardando || loading || !descripcion || !tipo || metraje === null || metraje === undefined}
        />
      </div>
    );
  };

  return (
    <div className="form-container">
      <Dialog
        visible={displayDialog}
        className="p-fluid product-dialog"
        onHide={limpiarFormulario}
        footer={footerCrearSubprod()}
        header="Crear Subproducto"
      >
        <Steps
          model={stepsItems}
          activeIndex={activeStep}
          onSelect={handleStepChange}
          className="cursor-pointer"
          style={{ cursor: 'pointer' }}
          readOnly={false}
        />

        <div className="card" style={{ display: activeStep === 0 ? 'block' : 'none' }}>
          <h6 className="mb-3">
            Información
          </h6>

          <span className="p-float-label mt-2 mb-3">
            <InputText
              id="descripcion"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value.toUpperCase())}
              className="p-inputtext-lg"
              placeholder="Ingrese la descripción del subproducto"
              required
              max={35}
            />
            <label htmlFor="descripcion">
              <i className="pi pi-file-edit mr-2"></i>Descripción *
            </label>
          </span>

          <span className="p-float-label mt-2 mb-3">
            <Dropdown
              id="tipo"
              value={tipo}
              onChange={(e) => setTipo(e.value)}
              options={tipoOptions || []}
              optionLabel="descripcion"
              optionValue="id"
              placeholder="Seleccione el tipo de subproducto"
              className="p-inputtext-lg"
            />
            <label htmlFor="tipo">
              <i className="pi pi-tag mr-2"></i>Tipo de Subproducto *
            </label>
          </span>

          <span className="p-float-label mt-2 mb-3">
            <InputNumber
              id="metraje"
              value={metraje === "" ? null : metraje}
              onValueChange={(e) => setMetraje(e.value)}
              className="p-inputtext-lg"
              placeholder="Ingrese el metraje del subproducto"
              required
              min={0}
              max={10000}
              locale="es-ES"
              inputMode="numeric"
              step={1}
              minFractionDigits={0}
              maxFractionDigits={0}
              allowEmpty
            />
            <label htmlFor="metraje"><i className="pi pi-th-large mr-1"></i>Metraje del Subproducto (m²) *</label>
          </span>

          {/* Navegación entre steps */}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button label="" rounded outlined icon="pi pi-arrow-right" iconPos="right" className="" onClick={() => setActiveStep(1)} />
          </div>
        </div>

        <div className="card" style={{ display: activeStep === 1 ? 'block' : 'none' }}>
          <FormCrearSubproductoFicha
            ref={fichaRef}
          />
          <div className="flex-space-between">
            <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(0)} />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default FormCrearSubproducto;
